import { render, staticRenderFns } from "./SectorForm.vue?vue&type=template&id=40ab56aa&"
import script from "./SectorForm.vue?vue&type=script&lang=js&"
export * from "./SectorForm.vue?vue&type=script&lang=js&"
import style0 from "./SectorForm.vue?vue&type=style&index=0&id=40ab56aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports